export const TRAIL_DASHBOARD_USER_PREF = 'TRAIL_DASHBOARD_USER_PREF'
export const PRIVILEGE_DASHBOARD_USER_PREF = 'PRIVILEGE_DASHBOARD_USER_PREF'
export const DATE_RANGE_PREFERENCE = 'DATE_RANGE_PREFERENCE'
export const DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE = 'DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE'
export const THREAT_PROGRESSION_DATE_RANGE_PREFERENCE = 'THREAT_PROGRESSION_DATE_RANGE_PREFERENCE'
export const PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE = 'PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE'
export const DETECTION_DATE_RANGE_PREFERENCE = 'DETECTION_DATE_RANGE_PREFERENCE'
export const ACTIVITIES_DATE_RANGE_PREFERENCE = 'ACTIVITIES_DATE_RANGE_PREFERENCE'
export const INSIGHTS_DATE_RANGE_PREFERENCE = 'INSIGHTS_DATE_RANGE_PREFERENCE'
export const HOST_INSIGHTS_DATE_RANGE_PREFERENCE = 'HOST_INSIGHTS_DATE_RANGE_PREFERENCE'
export const THREAT_HUNTING_DATE_RANGE_PREFERENCE = 'THREAT_HUNTING_DATE_RANGE_PREFERENCE'
export const ANOMALIES_DATE_RANGE_PREFERENCE = 'ANOMALIES_DATE_RANGE_PREFERENCE'



// WEBPACK FOOTER //
// ./src/store/modules/user_pref/user-pref.type.js